export enum TypeBooking {
  AIRPORT_ARIVAL = 1,
  AIRPORT_DEPARTURE = 2,
  HOURLY_CHARTER = 3,
  SINGLE_TRIP = 4,
  RETURN_TRIP = 5,
  CAREGIVER_SERVICE_ONLY = 6,
}

export enum ServiceTypeEnum {
  AIRPORT_ARIVAL = 'ARR',
  AIRPORT_DEPARTURE = 'DEP',
  HOURLY_CHARTER = 'DISP',
  SINGLE_TRIP = 'PTP',
  RETURN_TRIP = 'PTPR',
}

export enum AuthActionEnum {
  OPEN_LOGIN = 'OPEN_LOGIN',
  OPEN_SIGN_UP_BY_EMAIL = 'OPEN_SIGN_UP_BY_EMAIL',
  OPEN_SIGNUP = 'OPEN_SIGNUP',
  OPEN_FORGOT = 'OPEN_FORGOT',
}

export enum DatetimeFormatEnum {
  ddMMyyyy = 'dd/MM/yyyy',
  ddMMyyyyhmma = 'dd/MM/yyyy h:mm a',
  DDMMYYYYHHmma = 'dd/MM/yyyy hh:mm a',
  DDMMYYYYddddhmma = 'dd/MM/yyyy (EEEE) h:mma',
  yyyy = 'yyyy',
  mm = 'mm',
  dd = 'dd',
  MM = 'MM',
  HHmm = 'HH:mm',
  hmma = 'h:mma',
  hhmma = 'hh:mm a',
}

export const VehicleType = [
  { value: 'London Taxi', type: 'London Taxi', wheelchair: 1 },
  { value: 'Vellfire', type: 'Vellfire', wheelchair: 3 },
  {
    value: 'Wheelchair Accessible Van',
    type: 'Wheelchair Accessible Van',
    wheelchair: 3,
  },
];

export enum BookingStateEnum {
  CREATE = 'CREATE',
  IN_SERVICE = 'IN-SERVICE',
  SERVICE_END = 'SERVICE-END',
  AMENDMENT = 'AMENDMENT',
  IN_TRANSIT = 'In Transit',
  WaitingForAcknowLedgement = 'Waiting for Acknowledgement',
  Acknowledgement = 'Acknowledged',
  Collected = 'Collected',
  Started = 'Started',
  Successfull = 'Successfull',
  DRAFT = 'Draft',
  NEW = 'New Booking',
  QUOTE = 'New Quote',
  SEARCH = 'Searching For Driver',
  DRV_REQUEST = 'Waiting Driver Response',
  ASSIGN = 'Assigned',
  UNASSIGNED = 'Un-Assigned',
  DRV_REJECTED = 'Rejected By Driver',
  ACCEPTED = 'Job Accepted',
  OTW = 'On The Way To Pick Up',
  ARR = 'Driver Arrived at Pickup Point',
  INT = 'In Transit',
  DRV_DONE = 'Driver Job Done',
  PAX_NO_SHOW = 'Passenger No Show',
  DRV_NO_SHOW = 'Driver No Show',
  DRV_CANCEL = 'Cancelled By Driver',
  PSG_CANCEL = 'Cancelled By Passenger',
  CANCEL = 'Cancelled By Admin',
  UNKNOWN = 'Unknown',
}

export enum NumberOfPassengersEnum {
  numberOfPassengers = 6,
}

export enum AdditionalStopEnum {
  km = 5000,
}

export enum GSTEnum {
  DEFAULT_GST = 7, // 7%
  GST_FACTOR = 1.07, // 7%
}

export enum SuccessMessageEnum {
  resetPasswordLinkSent = 'Reset password link has been sent to your mailbox',
  regisSuccess = 'Please click on the verification link sent to your email account',
  avatarSuccess = 'Your profile image has been updated',
}

export enum ErrorMessageEnum {
  invalidFlightNumber = 'The Flight Number is invalid',
  loginFbFail = 'There is an error in logging you into this application. Please try again later.',
  additionalStopMustDifferent = 'The additional stop must be different from the pickup/dropoff location',
  imageTooLarge = 'Image is too large to upload',
  invalidEmail = 'Invalid email address',
  invalidPassword = 'At least 8 characters, must have uppercase and lowercase letters and numbers',
  hourLessThan24 = 'Number of hours must be less than 24',
  moreThan1Hour = 'Number of hours must be more than or equal to 1',
  max10Chars = 'Maximum 10 characters',
  requiredFieldMessage = 'This is a required field',
  mustGreaterThan0 = 'Must be greater than 0',
  mustLessThan150 = 'Must be less than 150',
  mustLessThan280 = 'Must be less than 280cm',
  mustLessThan650 = 'Must be less than 650kg',
  numberOfHourMustGreaterX = 'Must greater than or equal to {{X}}',
  mustGreaterThanToday = 'The pickup time must be greater than now',
  mustBookXHour = 'You must book {{X}} hours in advance',
  minReturnTime = 'The return time must be at least {{X}} longer than the pickup time',
  updatedSuccessful = 'Updated successful',
  passwordChangeSuccess = 'Your password has been changed successful',
  updatedCardSuccess = 'Updated card successful',
  addedCardSuccess = 'Added card successful',
  deletedCardSuccess = 'Deleted card successful',
  updatedBookingSuccess = 'Updated booking successful',
  cancelBookingSuccess = 'Cancel booking successful',
  activeSuccess = 'Activated successful',
  addedDefaultCardSuccess = 'Updated default card successful',
  maxNumberOfPassengersFieldMessage = 'Number of passengers must be less than or equal to 6',
  additionalStopMessage = 'Distance > 5 km between Additional Stop Point and Drop Off Point',
  maxNumberOfWheelchairExceed = 'Max number of Wheelchair exceeded',
  paymentSuccessful = 'Payment Successful',
  yourAccountBlocked = 'Your account is blocked, please contact Service Centre to request for assistance to unblock the account',
  bookingNotFound = 'Booking not found',
  selectCard = 'Please select card',
  errorStripe = 'Error occurs when handling with stripe',
  errorCancelBooking = 'Error occurs when cancelling booking',
  errorUpdateBooking = 'Error occurs when updating booking',
  errorCalcPrice = 'Error occurs when calculating price',
  otpIncorrect = 'OTP is incorrect',
  allowCookies = 'Pls try allowing cookies on your browser before attempting to sign in via Google',
}
